export enum SunAction {
  SUNRISE = 'sunrise',
  SUNSET = 'sunset',
}
